import { SvgIcon } from '@mui/material';
const ChevronDown = props => {
  return <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z" />
      <path fill="currentColor" d="M12 15.25a.741.741 0 0 1-.53-.22l-5-5A.75.75 0 0 1 7.53 9L12 13.44 16.47 9a.75.75 0 0 1 1.06 1l-5 5a.742.742 0 0 1-.53.25Z" />
    </SvgIcon>;
};
export default ChevronDown;